import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { TWButton } from '../../components/ui';

// FinanceSectionInner (finance-section.js) calls useAccountSession and
// useConnectInstance itself, and a component cannot catch an error thrown by
// its own render — a boundary defined inside FinanceSectionInner's own
// return statement would never even get built if either hook threw before
// that return runs (neither does today, but the guarantee should hold
// regardless). That is why finance-section.js is split into two components:
// FinanceSection (just this boundary) and FinanceSectionInner (everything
// else, including those two hooks and the <Outlet /> every page under
// /dashboard/finance renders through) — this has to sit one level up, as an
// ancestor of FinanceSectionInner, the same fix account-sections.js and
// connect-support-boundary.js applied on their own surfaces, and
// connect-settlement-boundary.js applies on the admin's mount site. Its own
// small component, not either of those: this sits in the finance route's own
// idiom (the same page shell finance-skeleton.js's FinanceSkeleton uses for
// this same route's loading state), and never imports either module's copy.
const FinanceRouteBoundary = ({ retryLabel = 'Refresh', children }) => (
  <ErrorBoundary
    fallbackRender={() => (
      <div className="flex min-h-[calc(100vh-4rem)] items-center justify-center bg-white px-4 dark:bg-slate-900/40">
        <div className="flex flex-col items-center gap-3 text-center">
          <p className="text-sm text-slate-600 dark:text-slate-300">
            We couldn't load your finance page just now.
          </p>
          <TWButton
            size="sm"
            label={retryLabel}
            onClick={() => window.location.reload()}
            aria-label={retryLabel + ' finance'}
          />
        </div>
      </div>
    )}
  >
    {children}
  </ErrorBoundary>
);

export default FinanceRouteBoundary;
